import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @typedef {import('types').Bookmark} Bookmark
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from '@haldor/ui';
import { PRESCHOOL } from 'constants/schoolTypes';
import { setPageTitle } from 'actions/header';
import { getMyBookmarks, deleteBookmark } from 'actions/bookmarks';
import { Block, Icon } from '@haldor/ui';
import LoadingCards from 'components/Cards/LoadingCard';
import './_UserBookmarks.scss';

var UserBookmarks = /*#__PURE__*/function (_Component) {
  _inherits(UserBookmarks, _Component);

  var _super = _createSuper(UserBookmarks);

  function UserBookmarks(props) {
    var _this;

    _classCallCheck(this, UserBookmarks);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('nav_bookmarks'));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.bookmarks == null || _this.props.bookmarks.length == 0) {
        _this.setState({
          loading: true
        });

        _this.props.getMyBookmarks().then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveBookmark", function (bookmark) {
      _this.props.deleteBookmark(bookmark.id);
    });

    _defineProperty(_assertThisInitialized(_this), "getReferenceLink", function (bookmark) {
      if (bookmark.referenceType == 'ASSIGNMENT') {
        return '/assignment/' + bookmark.referenceId;
      }

      if (bookmark.referenceType == 'PLAN') {
        return '/plan/' + bookmark.referenceId;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderBookmark", function (bookmark) {
      var link = _this.getReferenceLink(bookmark);

      return /*#__PURE__*/React.createElement("div", {
        className: "bookmark",
        key: bookmark.id
      }, /*#__PURE__*/React.createElement(Link, {
        to: link
      }, bookmark.title), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          return _this.onRemoveBookmark(bookmark);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }))));
    });

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(UserBookmarks, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentUser = this.props.currentUser;
      /**
       * @type {Bookmark[]} assignments
       */

      var assignments = _toConsumableArray(this.props.bookmarks).filter(function (bookmark) {
        return bookmark.referenceType == 'ASSIGNMENT';
      });
      /**
       * @type {Bookmark[]} plans
       */


      var plans = _toConsumableArray(this.props.bookmarks).filter(function (bookmark) {
        return bookmark.referenceType == 'PLAN';
      });

      var schoolType = currentUser.schools.getActiveSchool(currentUser.userId).type;
      var total = plans.length + assignments.length;
      return /*#__PURE__*/React.createElement("div", {
        className: "bookmarks user"
      }, this.state.loading ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      }) : /*#__PURE__*/React.createElement(Block, null, plans.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('plans')), /*#__PURE__*/React.createElement("div", {
        className: "bookmarks-list"
      }, plans.map(function (bookmark) {
        return _this2.renderBookmark(bookmark);
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      })) : null, assignments.length > 0 && schoolType != PRESCHOOL ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Assignments')), /*#__PURE__*/React.createElement("div", {
        className: "bookmarks-list"
      }, assignments.map(function (bookmark) {
        return _this2.renderBookmark(bookmark);
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      })) : null, total == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "text--center color--meta"
      }, this.props.translate('no-bookmarks')) : null));
    }
  }]);

  return UserBookmarks;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    bookmarks: state.Bookmarks.user,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getMyBookmarks: getMyBookmarks,
  setPageTitle: setPageTitle,
  deleteBookmark: deleteBookmark
})(UserBookmarks);